var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "start-screen"
  }, [_c("transition", {
    attrs: {
      name: "fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_vm.enter ? _c("div", {
    staticClass: "start-screen-container",
    on: {
      click: _vm.enterWebsite
    }
  }, [_c("div", {
    staticClass: "start-screen-container-logo-img"
  })]) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };